import {useQuery} from '@tanstack/react-query'

import useApi from 'hooks/api/useApi'

const useIsCryptoApiWorking = () => {
  const api = useApi()
  const {data, isLoading, ...queryRest} = useQuery([`isCryptoApiWorking`], () =>
    api.isCryptoApiWorking(),
  )
  return {
    isCryptoApiWorking: data,
    isLoadingCryptoApiWorking: isLoading,
    ...queryRest,
  }
}

export default useIsCryptoApiWorking
